import { render, staticRenderFns } from "./sitebeaconshealth.vue?vue&type=template&id=28a855e6&scoped=true"
import script from "./sitebeaconshealth.vue?vue&type=script&lang=js"
export * from "./sitebeaconshealth.vue?vue&type=script&lang=js"
import style0 from "./sitebeaconshealth.vue?vue&type=style&index=0&id=28a855e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a855e6",
  null
  
)

export default component.exports